(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderReservation',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.fb-toggle-vendor-booking').click(function _toggleComponents() {
			var checked = $(this).prop('checked'),
				vendor_id = $(this).data('vendor-id');

			$('.fb-component[data-vendor-id="' + vendor_id + '"]').prop('checked', checked);
		});

		$('.confirmation-seed').click(function _seeConfirmationNumber(e) {
			var main_conf_num = $('#fitbuilderreservation-primary_confirmation_number').val(),
				vendor_id     = $(this).data('vendor-id');
			e.preventDefault();

			if (main_conf_num === '') {
				Adzuki.StatusMessage('error', 'Please provide a confirmation number for the package');
			} else {
				$('.conf-nums').each(function _setEm() {
					if ($(this).data('package-vendor-id') === vendor_id && typeof $(this).attr('readonly') === 'undefined') {
						$(this).val(main_conf_num);
					}
				});
			}
		});
	};
}(jQuery, window.Adzuki || {}));
